import React from 'react';

const Routing = () => <>Routing</>;

export { Routing };
